import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';


@Component({
  selector: 'app-popup-inline',
  templateUrl: './popup-inline.component.html',
  styleUrls: ['./popup-inline.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PopupInlineComponent implements OnInit {

  @Output('close') closeEvent = new EventEmitter<void>();
  @Input('customClass') customClass: string;
  @Input('customName') customName: string;

  constructor() { }

  ngOnInit() {}


  doClose(){
    this.closeEvent.emit();
  }

}
